module.exports = __webpack_public_path__ + "static/media/locked.9a7709e4.png";